import GridAction from '../../components/common/GridAction';
import { AppPermissions } from '../../constants/Permissions';

export const makeScopeTemplateColumn = (onEdit, onDelete) => {
  const col = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      sortable: false,
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={onEdit}
            onDeleted={onDelete}
            editPermission={AppPermissions.ScopeTemplate.Edit}
            deletePermission={AppPermissions.ScopeTemplate.Delete}
            row={row.original}
            id={row.original.id}
          />
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
    },
  ] as Array<any>;

  return col;
};
